import { capitalizeFirstLetter } from '../../utils/string'
import { SOCIAL_BAR_ACTION_TYPES } from '../../../components/reactions/socialBarActionTypes'
import { CLASS_CONSTATNTS as ANALYTICS_ACTION_TYPES } from '../actions/analyticsActions'
import { CLASS_CONSTATNTS as AD_ACTION_TYPES } from '../actions/adActions'
import { YOUTUBE_ACTION_TYPES } from '../../../components/track_analytics_youtube_events/youtubeActions'
import { getCountryCode } from '../../providers/geolocationProvider'

export default function gtmService() {
  window.dataLayer = window.dataLayer || []
  const GTM_ACTIONS = {
    [AD_ACTION_TYPES.ADS.ACTIONS.AD_BLOCK_DETECTION_FINISHED]: {
      normalizeDataFunction: 'normalizeAdblockData',
    },
    [ANALYTICS_ACTION_TYPES.ANALYTICS.ACTIONS.SCROLL_ANCHOR_REACHED]: {},
    // [SOCIAL_BAR_ACTION_TYPES.REACTIONS.SEND_VOTE]: {},
    [ANALYTICS_ACTION_TYPES.ANALYTICS.ACTIONS.CLICK_EVENT]: {
      normalizeDataFunction: 'normalizeClickData',
    },
    'ANALYTICS:ACTIONS:SCROLL_ANCHOR_REACHED': {},
    'REACTIONS:SEND_VOTE': {},

    [YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_PLAY]: {},
    [YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_PAUSE]: {},
    [YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_PERCENTAGE_CHANGE]: {},
    [YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_COMPLETE]: {},
  }

  function unlessStringToString(value) {
    return typeof value !== 'string' ? value.toString() : value
  }

  function ifNotCategoryKeyRunFn(fn, key, value) {
    return key === 'category' ? capitalizeFirstLetter(value) : fn(value).toLowerCase()
  }

  function normalizeEventData(eventPayload) {
    return Object.entries(eventPayload).reduce(
      (acc, [key, value]) => {
        return value === undefined
          ? acc
          : { ...acc, [`GA_event_${key}`]: ifNotCategoryKeyRunFn(unlessStringToString, key, value) }
      },
      { event: 'GTM event To GA' }
    )
  }

  const dataConverters = {
    normalizeAdblockData(state) {
      const isAdBlocked = state.detected ? 'yes' : 'no'
      return { event: 'GTM late data to GA', isAdBlock: isAdBlocked }
    },

    normalizeClickData(state) {
      const {
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: sub_label,
      } = state.payload

      let normalizedEventData = normalizeEventData({ category, action, label, sub_label })

      const gtmAnchorCallback = state.payload.gtmAnchorCallback

      if (gtmAnchorCallback) {
        Object.assign(normalizedEventData, gtmAnchorCallback)
      }
      return normalizedEventData
    },
  }

  return async function gtmPushToDataLayer(gtmReduxAction) {
    const currentGtmAction = GTM_ACTIONS[gtmReduxAction.type]
    if (currentGtmAction === undefined) {
      return
    }
    let finalNormalizedGtmData
    const { category, action, label, sub_label, value } =
      gtmReduxAction.state.payload || gtmReduxAction.state || {}
    const valueOrSubLabel = sub_label || value
    const normalizeDataMethodPerAction = dataConverters[currentGtmAction.normalizeDataFunction]
    if (category && action && label) {
      finalNormalizedGtmData = normalizeEventData({
        category,
        action,
        label,
        sub_label: valueOrSubLabel,
      })
    } else if (currentGtmAction.normalizeDataFunction === 'normalizeAdblockData') {
      finalNormalizedGtmData = {
        ...normalizeDataMethodPerAction(gtmReduxAction.state),
        ...{ geoDetected: await getCountryCode() },
      }
    } else if (normalizeDataMethodPerAction) {
      finalNormalizedGtmData = normalizeDataMethodPerAction(gtmReduxAction.state)
    } else {
      return
    }
    window.dataLayer.push(finalNormalizedGtmData)
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/GtmService.js